export default __webpack_public_path__ + "ff49f440dac8e12abcfa9b97478fbcf9.png";